import { render, staticRenderFns } from "./UnitStar.vue?vue&type=template&id=d805eeec&"
import script from "./UnitStar.vue?vue&type=script&lang=js&"
export * from "./UnitStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d805eeec')) {
      api.createRecord('d805eeec', component.options)
    } else {
      api.reload('d805eeec', component.options)
    }
    module.hot.accept("./UnitStar.vue?vue&type=template&id=d805eeec&", function () {
      api.rerender('d805eeec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22nZ4mBGEQlD7/JS/UnitStar.vue"
export default component.exports